<div *routerOuter class="row">
  <div class="col col-120 col-lg-100 col-xl-80" *ngIf="item">

    <form-group-context label="ID">
      <span>{{ item.id }}</span>
    </form-group-context>

    <form-group-context label="Created At">
      <span>{{ item.createdAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Updated At">
      <span>{{ item.updatedAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Account">
      <entity-link type="account" [item]="item.account" [name]="item.account?.email" [relativePath]="true"></entity-link>
      <p *ngIf="item.account?.meta">
        {{ item.account?.meta | json}}
      </p>
    </form-group-context>

    <form-group-context label="Meta">
      <p *ngIf="item.meta">
        {{ item.meta | json}}
      </p>
    </form-group-context>

    <form-group-context label="Device">
     <div *ngFor="let device of item.devices">
        <span>
        {{ device?.idfa || device?.vendorId || device?.androidId }} <br>
       </span>
       <small class="text-muted">{{ device?.id }}</small>
     </div>
    </form-group-context>


    <form-group-context label="Store">
      <entity-link type="store" [item]="item.store" [relativePath]="true"></entity-link>
    </form-group-context>

    <form-group-context label="Add purchase">
      <button class="btn btn-icon btn-secondary"
              [hidden]="!item"
              (click)="addPurchase()">
        <icon-plus></icon-plus>
        <span class="ml-2">Add purchase</span>
      </button>
    </form-group-context>

    <form-group-context label="Action">
      <btn-delete form actions type="user"
                  [name]="item.id"
                  (delete)="delete($event)">
      </btn-delete>
    </form-group-context>


  </div>
</div>
